import { lines, type Recipe } from './recipes'

export type SheetStyle = 'page' | 'card'

// The facts printed under a recipe's title: only what the family actually recorded, never a guess. Servings and
// times aren't kept yet, so they aren't printed.
export function sheetFacts(recipe: Pick<Recipe, 'from' | 'book'>): [label: string, value: string][] {
  const facts: [string, string][] = []
  if (recipe.from) facts.push(['From', recipe.from.name])
  if (recipe.book?.title.trim()) facts.push(['Book', recipe.book.title.trim()])
  return facts
}

export function sheetText(recipe: Pick<Recipe, 'ingredients' | 'steps' | 'notes'>) {
  return { ingredients: lines(recipe.ingredients), steps: lines(recipe.steps), notes: recipe.notes.trim() }
}

// How a note card holds its recipe: everything on the front, or else the directions and notes turned over to the
// back (turning the card over beats small type), then the type a little smaller each time it still doesn't fit.
// Grown is the last resort: the card gets taller rather than cut a word off.
export type CardFit = { back: boolean; scale: number; grown?: boolean }

export function cardFits(hasBack: boolean): CardFit[] {
  const scales = [1, 0.9, 0.8, 0.7]
  const fits = hasBack
    ? [{ back: false, scale: 1 }, ...scales.map((scale) => ({ back: true, scale }))]
    : scales.map((scale) => ({ back: false, scale }))
  return [...fits, { ...fits.at(-1)!, grown: true }]
}
